/*
 *
 * FeatureConfiguration constants
 *
 */

const BASE_ACTION_CONSTANT = 'app/FeatureConfiguration';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const FETCH_SETTLEMENT_CONFIG = `${BASE_ACTION_CONSTANT}/FETCH_SETTLEMENT_CONFIG`;

export const UPDATE_EASY_SPLIT_CONFIG = `${BASE_ACTION_CONSTANT}/UPDATE_EASY_SPLIT_CONFIG`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const REQUEST_ON_DEMAND_ACTIVATION = `${BASE_ACTION_CONSTANT}/REQUEST_ON_DEMAND_ACTIVATION`;

export const NOT_REQUESTED = 'NOT_REQUESTED';

export const IN_REVIEW = 'IN_REVIEW';

export const REJECTED = 'REJECTED';

export const ACTIVE = 'ACTIVE';

export const DISABLED = 'DISABLED';

export const ADD = 'ADD';

export const SUBTRACT = 'SUBTRACT';

export const ORDER_SPLIT_DELAY_MAX_VALUE = 45;

export const DEFER_SETTLEMENT_MAX_VALUE = 45;

export const SETTLEMENTS_CYCLE_OPTIONS = {
  INSTANT_SETTLEMENTS: [
    { key: 6, text: 'T+0: Instant settlements every hour.' },
    { key: 7, text: 'T+0: Instant settlements every 3 hours.' },
    { key: 3, text: 'T+0: Instant settlements at 11 AM and 5 PM.' },
  ],
  VENDOR_SETTLEMENTS: [
    { key: 1, text: 'T+1 settlement at 11 AM' },
    { key: 2, text: 'T+2 settlement at 11 AM' },
    {
      key: 4,
      text:
        'All transactions from T-1 : 2 PM to T+0 : 2 PM settled at T+0 : 3 PM',
    },
    {
      key: 5,
      text: 'Same day settlements: All transactions till 5:30 PM at 6 PM',
    },
  ],
};

export const DEFAULT_PAYLOAD = {
  adminId: '507',
};

export const KNOW_MORE_LINKS = {
  ORDER_SPLIT_DELAY:
    'https://www.cashfree.com/docs/payments/split/settlements/delay/order-level#order-split-delay-post-successful-payment',
  DEFER_SETTLEMENT:
    'https://www.cashfree.com/docs/payments/split/settlements/delay/vendor-level#defer-settlement',
  ON_DEMAND_SETTLEMENT:
    'https://www.cashfree.com/docs/payments/split/vendor/dashboard/settlements#on-demand-settlement',
  VENDOR_INSTANT_SETTLEMENT:
    'https://www.cashfree.com/docs/payments/split/vendor/dashboard/settlements#instant-settlement',
  VENDOR_STANDARD_SETTLEMENT:
    'https://www.cashfree.com/docs/payments/split/vendor/dashboard/settlements#standard-settlement',
  INTEGRATE_EASY_SPLIT: 'https://www.cashfree.com/docs/payments/split/features',
};

export const DEFAULT_MAX_DELAY_VALUE = 1;
